/**
 * Onde este mesmo bundle esta rodando.
 *
 * O front e um so — web, desktop (Tauri) e o build empacotado usam o mesmo
 * codigo. Alguns recursos, porem, so existem no aplicativo instalado: abrir uma
 * aplicacao externa precisa de uma webview nativa, coisa que o navegador nao
 * oferece a uma pagina.
 */

/** Roda dentro do Orbind Desktop? */
export function isDesktop(): boolean {
  if (typeof window === 'undefined') return false
  const w = window as unknown as Record<string, unknown>
  // Tauri 2 injeta `__TAURI_INTERNALS__` na webview. `__TAURI__` fica como
  // reserva: ele existe quando `withGlobalTauri` esta ligado e em versoes 1.x.
  return w.__TAURI_INTERNALS__ !== undefined || w.__TAURI__ !== undefined
}

export type SistemaOperacional = 'windows' | 'macos' | 'linux' | 'outro'

/** Sistema de quem esta acessando — usado para oferecer o instalador certo. */
export function sistemaOperacional(): SistemaOperacional {
  if (typeof navigator === 'undefined') return 'outro'
  const alvo = `${navigator.userAgent} ${navigator.platform ?? ''}`.toLowerCase()
  if (alvo.includes('win')) return 'windows'
  if (alvo.includes('mac')) return 'macos'
  // android tambem casa com "linux"; so interessa o desktop aqui
  if (alvo.includes('linux') && !alvo.includes('android')) return 'linux'
  return 'outro'
}

export const NOME_DO_SISTEMA: Record<SistemaOperacional, string> = {
  windows: 'Windows',
  macos: 'macOS',
  linux: 'Linux',
  outro: 'seu sistema',
}

/** Endereço do instalador servido pelo próprio Orbind. */
export function urlDeDownload(sistema?: SistemaOperacional): string {
  const alvo = sistema ?? sistemaOperacional()
  const base = import.meta.env.DEV ? (import.meta.env.VITE_API_URL ?? 'http://localhost:3333') : ''
  return alvo === 'outro' ? `${base}/download/desktop` : `${base}/download/desktop?platform=${alvo}`
}
